import React, { useCallback, useEffect, useState } from 'react';
import { GlobalButtonFinal, ModalsWrapper, ModalWindow } from '../GlobalStyles';

import { faCheck, faChevronLeft, faChevronRight, faRotateRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledPagination, StyledProductsContent } from '../../pages/products/styles/ProductsStyles';
import Product from '../../pages/products/Product';
import * as Sentry from '@sentry/nextjs';
import { getCookie } from 'cookies-next';

export default function DialogChooseProductShrink({
    masterProductShrinkUUID,
    productInsideShrinkProductType,
    plugin,
    productInsideShrinkVolume,
    versionUUIDShrinkInside,
    setVersionUUIDShrinkInside,
    versionProductShrinkUUID,
    setProductInsideShrinkAPI,
    displayCanvasThumbnail,
    setDisplayCanvasThumbnail,
    toggleEditorWindowInsideShrinkProducts,
    windowEditorType,
}) {
    const [windowEditorTypeInner, setWindowEditorTypeInner] = useState('');

    const [showLoading, setShowLoading] = useState(false);


    const [editorShow, setEditorShow] = useState(false);
    const [editorTransitionShow, setEditorTransitionShow] = useState(false);

    const changeEditorShow = variable => {
        if (variable === true) {
            setEditorShow(variable);
            setTimeout(function () {
                setEditorTransitionShow(true);
            }, 1);
        } else {
            setDisplayCanvasThumbnail(false);
            setEditorTransitionShow(false);
            setTimeout(function () {
                setEditorShow(variable);
            }, 500);
        }
    };

    const [dialogChooseShrinkInited, setDialogChooseShrinkInited] = useState(0);

    const [showEditorDialog, setShowEditorDialog] = useState(false);

    ////////////

    const toggleEditorWindowInsideShrinkProductsInside = useCallback((): void => {
        if (showEditorDialog) {
            setDisplayCanvasThumbnail(false);
            changeEditorShow(false);
        } else {
            setShowTypeShrinkInside('mainProducts');
            changeEditorShow(true);
        }

        if (!dialogChooseShrinkInited) {
            setDialogChooseShrinkInited(1);
        }
        setWindowEditorTypeInner('chooseInsideShrink');

    }, []);
    useEffect(() => {

        toggleEditorWindowInsideShrinkProducts && toggleEditorWindowInsideShrinkProducts(toggleEditorWindowInsideShrinkProductsInside);
    }, [toggleEditorWindowInsideShrinkProducts, toggleEditorWindowInsideShrinkProductsInside]);

    useEffect(() => {

        if (dialogChooseShrinkInited === 1) {
            initShrinkInside(currentPage);
        }
    }, [dialogChooseShrinkInited]);

    //

    //////////
    const closeModalOutsideClick = e => {
        if (e.target.getAttribute('data-closemodal') === 'true') {
            changeEditorShow(false);
            setDisplayCanvasThumbnail(false);
        }
    };

    const [showTypeShrinkInside, setShowTypeShrinkInside] = useState('mainProducts');

    useEffect(() => {
        if (windowEditorType) {
            setWindowEditorTypeInner(windowEditorType);
        }
    }, [windowEditorType]);

    const setModalShow = (variable, type, parentUUID) => {
        if (variable === true) {
            setTimeout(function () {
                setModalTransitionShow(true);
            }, 1);
        } else {
            setModalTransitionShow(false);
            setTimeout(function () {
                //setLoadProductsShowVariable(variable);
            }, 300);
        }
    };

    const [productsInsideShrinkAvailableInnerVersion, setProductsInsideShrinkAvailableInnerVersion] = useState([]);
    const [productsInsideShrinkAvailableInner, setProductsInsideShrinkAvailableInner] = useState([]);

    const [modalTransitionShow, setModalTransitionShow] = useState(false);

    const saveShrinkChooseVersionProductAPI = () => {
        changeEditorShow(false);
        setDisplayCanvasThumbnail(false);
        setProductInsideShrinkAPI(versionUUIDShrinkInside);
    };
    const onClickChooseShrinkFunction = productUUID => {
        if (windowEditorTypeInner === 'chooseInsideShrinkVersion') {
            //  loadProductsInsideShrink(productUUID);

            setVersionUUIDShrinkInside(productUUID);
        } else {
            setShowTypeShrinkInside('versionProducts');

            Object.keys(productsInsideShrinkAvailableInner).map(key => {
                if (productsInsideShrinkAvailableInner[key].uuid === productUUID) {
                    setProductsInsideShrinkAvailableInnerVersion(productsInsideShrinkAvailableInner[key].versions);

                    setWindowEditorTypeInner('chooseInsideShrinkVersion');
                }
            });
        }

    };

    var neco = 0;

    const [totalPages, setTotalPages] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);

    const initShrinkInside = pageValue => {
        var token2 = getCookie('userTeam');
        var tokenMain = getCookie('userTeam');
        if (plugin) {
            tokenMain = getCookie('pluginLoginSessionToken');
            token2 = getCookie('pluginLoginSessionTeamToken');
        }

        var page = 1;
        if (pageValue) {
            page = pageValue;
        }

        fetch(
            process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH +
                'products' +
                '?&product_type=' +
                productInsideShrinkProductType +
                '&volume=' +
                productInsideShrinkVolume +
                '&items_per_page=' +
                4 +
                '?page=' +
                pageValue,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + token2, // notice the Bearer before your token
                },
            },
        )
            .then(response => response.json())
            .then(function (dataProducts) {
                if (dataProducts.message !== undefined) {
                    Sentry.captureException('products' + ': ' + dataProducts.message + ' : ' + getCookie('userMail'));
                }

                setCurrentPage(dataProducts.page);

                setTotalPages(dataProducts.pages);

                setProductsInsideShrinkAvailableInner(dataProducts.data);
                setShowLoading(false);

            });

        //

        // if(productsInsideShrinkAvailable && productsInsideShrinkAvailable.length > 0){
        //     setProductsInsideShrinkAvailableInner(productsInsideShrinkAvailable);
        //
        // }
    };

    useEffect(() => {
        if (productsInsideShrinkAvailableInner && productsInsideShrinkAvailableInner.length > 0) {

            Object.keys(productsInsideShrinkAvailableInner).map(key => {

            });
        }
    }, [productsInsideShrinkAvailableInner]);

    useEffect(() => {
        if (productsInsideShrinkAvailableInnerVersion && productsInsideShrinkAvailableInnerVersion.length > 0) {
            Object.keys(productsInsideShrinkAvailableInnerVersion).map(keyVersion => {

            });
        }
    }, [productsInsideShrinkAvailableInnerVersion]);

    return (
        <>
            <ModalsWrapper
                className={`editorCheck  ${editorTransitionShow ? 'showTransition' : 'hideTransition'} ${!editorShow ? 'hiddeComplete' : ''}`}
                data-closemodal={true}
                onClick={e => closeModalOutsideClick(e)}
            >
                <ModalWindow className={'center chooseShrink'} id={'editorProductDialog'} style={{ background: '#f2f2f2', overflow: 'scroll' }}>

                    {showLoading ?
                        <div className={`uploading-loading `}>
                            <div>
                                <img src={'/logoAnimate.svg'} />
                                <h4>Loading list of available products...</h4>
                            </div>
                        </div>
                    : null}


                    <div className={'modal-header'} style={{ height: '110px' }}>
                        <h4></h4>
                    </div>

                    <div className={'modal-content shareProduct'} style={{ display: 'block' }}>
                        <>
                            <StyledProductsContent className={`chooseInsideShrink ${showTypeShrinkInside !== 'mainProducts' ? 'hiddeComplete' : ''}`}>
                                <div id="content" style={{ textAlign: 'center' }}>
                                    {productsInsideShrinkAvailableInner !== undefined && productsInsideShrinkAvailableInner.length > 0 ? (
                                        <>
                                            {Object.keys(productsInsideShrinkAvailableInner).map(key => {
                                                return (
                                                    <Product
                                                        onlyBackground={'true'}
                                                        productType={'GRID'}
                                                        productInsideShrink={true}
                                                        threeID={'threeGrid'}
                                                        key={'Product' + key}
                                                        productThumbnail={productsInsideShrinkAvailableInner[key].thumbnail.fallback}
                                                        productID={productsInsideShrinkAvailableInner[key].uuid}
                                                        productSelected={productsInsideShrinkAvailableInner[key].productSelected}
                                                        productName={productsInsideShrinkAvailableInner[key].name}
                                                        onClickChooseShrinkFunction={onClickChooseShrinkFunction}
                                                        productShrinkSelected={masterProductShrinkUUID === productsInsideShrinkAvailableInner[key].uuid ? true : false}
                                                        classes={`showProduct `}
                                                        productBrand={'brand'}
                                                        productClient={'client'}
                                                        productEdition={'edition'}
                                                        productVersions={productsInsideShrinkAvailableInner[key].versions.length}
                                                        productVolume={productsInsideShrinkAvailableInner[key].package.volume.name}
                                                        productPackageGroup={productsInsideShrinkAvailableInner[key].package.groups[0].name}
                                                        productPackageLastUUID={productsInsideShrinkAvailableInner[key].versions[productsInsideShrinkAvailableInner[key].versions.length - 1].uuid}
                                                    />
                                                );
                                            })}
                                        </>
                                    ) : null}
                                </div>
                            </StyledProductsContent>

                            {windowEditorTypeInner === 'chooseInsideShrinkVersion' ? (
                                <StyledProductsContent className={`chooseInsideShrink ${showTypeShrinkInside !== 'versionProducts' ? 'hiddeComplete' : ''}`}>
                                    <div id="content" style={{ textAlign: 'center' }}>
                                        {productsInsideShrinkAvailableInnerVersion.length > 0 && productsInsideShrinkAvailableInnerVersion !== undefined ? (
                                            <>
                                                {Object.keys(productsInsideShrinkAvailableInnerVersion).map(key => {
                                                    return (
                                                        <Product
                                                            onlyBackground={'true'}
                                                            productType={'GRID'}
                                                            productInsideShrink={true}
                                                            productInsideShrinkVersion={true}
                                                            threeID={'threeGrid'}
                                                            productThumbnail={productsInsideShrinkAvailableInnerVersion[key].thumbnail.fallback}
                                                            key={'Product' + key}
                                                            productShrinkSelected={versionProductShrinkUUID === productsInsideShrinkAvailableInnerVersion[key].uuid ? true : false}
                                                            productID={productsInsideShrinkAvailableInnerVersion[key].uuid}
                                                            //productSelected={productsInsideShrinkAvailableInnerVersion[key].productSelected}
                                                            productName={productsInsideShrinkAvailableInnerVersion[key].name}
                                                            onClickChooseShrinkFunction={onClickChooseShrinkFunction}
                                                            classes={`showProduct `}
                                                            productBrand={'brand'}
                                                            productClient={'client'}
                                                            productEdition={'edition'}
                                                            productVersions={'unset'}

                                                            /*  productVolume={productsInsideShrinkAvailableInnerVersion[key].package.volume}*/
                                                            //     productPackageGroup={productsInsideShrinkAvailableInnerVersion[key].package.groups[0].name}
                                                            //   productPackageLastUUID={productsInsideShrinkAvailableInnerVersion[key].versions[productsInsideShrinkAvailableInnerVersion[key].versions.length-1].uuid}
                                                        />
                                                    );
                                                })}
                                            </>
                                        ) : null}
                                    </div>
                                </StyledProductsContent>
                            ) : null}
                        </>
                    </div>
                    <div className={'modal-buttons'} style={{ height: '45px' }}></div>
                </ModalWindow>
            </ModalsWrapper>

            <canvas
                id="c"
                style={
                    displayCanvasThumbnail
                        ? { zIndex: '9999999' }
                        : {
                              zIndex: '9999999',
                              display: 'none',
                          }
                }
            ></canvas>
            <ModalsWrapper
                className={`editorCheck  ${editorTransitionShow ? 'showTransition' : 'hideTransition'} ${!editorShow ? 'hiddeComplete' : ''}`}
                data-closemodal={true}
                style={{ background: 'transparent', zIndex: '10000000' }}
                onClick={e => closeModalOutsideClick(e)}
            >
                <ModalWindow className={'center chooseShrink'} id={'editorProductDialog'} style={{ background: 'transparent', overflow: 'scroll' }}>
                    {showLoading ?
                        <div className={`uploading-loading `}>
                            <div>
                                <img src={'/logoAnimate.svg'} />
                                <h4>Loading list of available products...</h4>
                            </div>
                        </div>
                        : null}
                    <div className={'modal-header'} style={{ height: '110px' }}>
                        <h4>Choose product inside of shrink foil</h4>
                    </div>

                    <div className={'modal-content shareProduct'} style={{ display: 'block' }}>
                        <>
                            <StyledProductsContent className={`chooseInsideShrink ${showTypeShrinkInside !== 'mainProducts' ? 'hiddeComplete' : ''}`}>
                                <div id="content" style={{ textAlign: 'center' }}>
                                    {productsInsideShrinkAvailableInner !== undefined && productsInsideShrinkAvailableInner.length > 0 ? (
                                        <>
                                            {Object.keys(productsInsideShrinkAvailableInner).map(key => {
                                                return (
                                                    <Product
                                                        onlyBackground={'false'}
                                                        productType={'GRID'}
                                                        productInsideShrink={true}
                                                        threeID={'threeGrid' + productsInsideShrinkAvailableInner[key].uuid}
                                                        key={'Product' + key}
                                                        productThumbnail={productsInsideShrinkAvailableInner[key].thumbnail.fallback}
                                                        productShrinkSelected={masterProductShrinkUUID === productsInsideShrinkAvailableInner[key].uuid ? true : false}
                                                        productID={productsInsideShrinkAvailableInner[key].uuid}
                                                        productSelected={productsInsideShrinkAvailableInner[key].productSelected}
                                                        productName={productsInsideShrinkAvailableInner[key].name}
                                                        onClickChooseShrinkFunction={onClickChooseShrinkFunction}
                                                        classes={`showProduct `}
                                                        productBrand={'brand'}
                                                        productClient={'client'}
                                                        productEdition={'edition'}
                                                        productVersions={productsInsideShrinkAvailableInner[key].versions.length}
                                                        productVolume={productsInsideShrinkAvailableInner[key].package.volume.name}
                                                        productPackageGroup={productsInsideShrinkAvailableInner[key].package.groups[0].name}
                                                        productPackageLastUUID={productsInsideShrinkAvailableInner[key].versions[productsInsideShrinkAvailableInner[key].versions.length - 1].uuid}
                                                    />
                                                );
                                            })}
                                        </>
                                    ) : // <h2>Nemáš žádné produkty, začni přidáním nového</h2>
                                    null}

                                    {totalPages > 1 ? (
                                        <StyledPagination className={'pagination'}>
                                            {currentPage > 1 ? (
                                                <button onClick={() => initShrinkInside(currentPage - 1)}>
                                                    {' '}
                                                    <FontAwesomeIcon icon={faChevronLeft} />{' '}
                                                </button>
                                            ) : null}

                                            <span>
                                                {currentPage} of {totalPages}
                                            </span>

                                            {currentPage < totalPages ? (
                                                <button onClick={() => initShrinkInside(currentPage + 1)}>
                                                    {' '}
                                                    <FontAwesomeIcon icon={faChevronRight} />{' '}
                                                </button>
                                            ) : null}
                                        </StyledPagination>
                                    ) : null}
                                </div>
                            </StyledProductsContent>

                            {windowEditorTypeInner === 'chooseInsideShrinkVersion' ? (
                                <StyledProductsContent className={`chooseInsideShrink ${showTypeShrinkInside !== 'versionProducts' ? 'hiddeComplete' : ''}`}>
                                    <div id="content" style={{ textAlign: 'center' }}>
                                        {productsInsideShrinkAvailableInnerVersion.length > 0 && productsInsideShrinkAvailableInnerVersion !== undefined ? (
                                            <>
                                                {Object.keys(productsInsideShrinkAvailableInnerVersion).map(key => {
                                                    return (
                                                        <Product
                                                            onlyBackground={'false'}
                                                            productType={'GRID'}
                                                            productInsideShrink={true}
                                                            productInsideShrinkVersion={true}
                                                            threeID={'threeGrid' + productsInsideShrinkAvailableInnerVersion[key].uuid}
                                                            key={'Product' + key}
                                                            productThumbnail={productsInsideShrinkAvailableInnerVersion[key].thumbnail.fallback}
                                                            productShrinkSelected={versionProductShrinkUUID === productsInsideShrinkAvailableInnerVersion[key].uuid ? true : false}
                                                            productID={productsInsideShrinkAvailableInnerVersion[key].uuid}
                                                            //productSelected={productsInsideShrinkAvailableInnerVersion[key].productSelected}
                                                            productName={productsInsideShrinkAvailableInnerVersion[key].name}
                                                            onClickChooseShrinkFunction={onClickChooseShrinkFunction}
                                                            classes={`showProduct `}
                                                            productBrand={'brand'}
                                                            productClient={'client'}
                                                            productEdition={'edition'}
                                                            productVersions={'unset'}
                                                            /*  productVolume={productsInsideShrinkAvailableInnerVersion[key].package.volume}*/
                                                            //     productPackageGroup={productsInsideShrinkAvailableInnerVersion[key].package.groups[0].name}
                                                            //   productPackageLastUUID={productsInsideShrinkAvailableInnerVersion[key].versions[productsInsideShrinkAvailableInnerVersion[key].versions.length-1].uuid}
                                                        />
                                                    );
                                                })}
                                            </>
                                        ) : // <h2>Nemáš žádné produkty, začni přidáním nového</h2>
                                        null}
                                    </div>
                                </StyledProductsContent>
                            ) : null}
                        </>
                    </div>
                    <div className={'modal-buttons'}>
                        <GlobalButtonFinal style={{ width: 'unset' }} className={'borderLightGray cancel btn-circle'} onClick={() => changeEditorShow(false)}>
                            Cancel
                        </GlobalButtonFinal>

                        <GlobalButtonFinal style={{ width: 'unset', marginLeft: '15px' }} className={'borderBlue btn-circle'} onClick={() => saveShrinkChooseVersionProductAPI()}>
                            <FontAwesomeIcon icon={faCheck} /> OK
                        </GlobalButtonFinal>
                    </div>
                </ModalWindow>
            </ModalsWrapper>
        </>
    );
}
